export const INIT = '@@services_INIT';
export const INIT_SUCCESS = '@@services_INIT_SUCCESS';
export const INIT_ERROR = '@@services_INIT_ERROR';

export const CONFIGURATION_SUCCESS = '@@services_CONFIGURATION_SUCCESS';
export const CONFIGURATION_ERROR = '@@services_CONFIGURATION_ERROR';

export const CATEGORIES_LIST_SUCCESS = '@@services_CATEGORIES_LIST_SUCCESS';
export const CATEGORIES_LIST_ERROR = '@@services_CATEGORIES_LIST_ERROR';

export const PROVIDERS_LIST_SUCCESS = '@@services_PROVIDERS_LIST_SUCCESS';
export const PROVIDERS_LIST_ERROR = '@@services_PROVIDERS_LIST_ERROR';

export const START_COUNTS_LIST_SUCCESS = '@@services_START_COUNTS_LIST_SUCCESS';
export const START_COUNTS_LIST_ERROR = '@@services_START_COUNTS_LIST_ERROR';

export const SUBSCRIPTION_TYPES_LIST_SUCCESS = '@@services_SUBSCRIPTION_TYPES_LIST_SUCCESS';
export const SUBSCRIPTION_TYPES_LIST_ERROR = '@@services_START_COUNTS_LIST_ERROR';

export const SERVICE_TYPE_LIST_SUCCESS = '@@services_SERVICE_TYPE_LIST_SUCCESS';
export const SERVICE_TYPE_LIST_ERROR = '@@services_SERVICE_TYPE_LIST_ERROR';

export const SERVICE_CHECKED_MASS_ADD = '@@services_SERVICE_CHECKED_MASS_ADD';
export const SERVICE_CHECKED_MASS_REMOVE = '@@services_SERVICE_CHECKED_MASS_REMOVE';
export const SERVICE_CHECKED_SET_STATE = '@@services_SERVICE_CHECKED_SET_STATE';

export const CATEGORY_SERVICES_CHECKED_ADD = '@@services_CATEGORY_SERVICES_CHECKED_ADD';
export const CATEGORY_SERVICES_CHECKED_REMOVE = '@@services_CATEGORY_SERVICES_CHECKED_REMOVE';

export const SERVICE_DUPLICATE = '@@services_SERVICE_DUPLICATE';

export const SERVICE_DELETE = '@@services_SERVICE_DELETE';

export const CATEGORY_DELETE_SUCCESS = '@@services_CATEGORY_DELETE_SUCCESS';
export const CATEGORY_DELETE_ERROR = '@@services_CATEGORY_DELETE_ERROR';
export const CATEGORY_SORTABLE_SUCCESS = '@@services_CATEGORY_SORTABLE_SUCCESS';

export const CHANGE_STATUS = '@@services_CHANGE_STATUS';
export const CHANGE_STATUS_SUCCESS = '@@services_CHANGE_STATUS_SUCCESS';
export const CHANGE_STATUS_ERROR = '@@services_CHANGE_STATUS_ERROR';

export const SERVICES_MASS_CHANGE_STATUS_SUCCESS = '@@services_SERVICES_MASS_CHANGE_STATUS_SUCCESS';
export const SERVICES_MASS_CHANGE_DRIP_FEED_SUCCESS = '@@services_SERVICES_MASS_CHANGE_DRIP_FEED_SUCCESS';
export const SERVICES_MASS_DELETE_SUCCESS = '@@services_SERVICES_MASS_DELETE_SUCCESS';
export const SERVICES_MASS_ASSIGN_CATEGORY = '@@services_SERVICES_MASS_ASSIGN_CATEGORY';
export const SERVICES_MASS_RESET_CUSTOM_RATES = '@@services_SERVICES_MASS_RESET_CUSTOM_RATES';
export const SERVICES_SORTABLE_SUCCESS = '@@services_SERVICES_SORTABLE_SUCCESS';
